import React from 'react';

import { Select as SelectStyleguide } from '@eika/select';

import { SvarId } from '../../types/generated-types';
import { updateSvarId } from '../reducer/sporsmalsflyt-actions';
import { SelectAlternativ } from '../reducer/sporsmalsflyt-types';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentSelectSporsmal } from './select-types';

interface SelectValue {
    text: string;
    id: string;
    key: string;
    value: SvarId;
    disabled: boolean;
}

export const toValues = (alternativer: SelectAlternativ[], prefix = ''): SelectValue[] =>
    alternativer.map((alternative) => ({
        text: alternative.tekst,
        value: alternative.id,
        key: alternative.id,
        id: `${prefix}${alternative.id}`,
        disabled: false,
    }));

interface Props {
    currentSporsmal: CurrentSelectSporsmal;
    showFeilmelding: boolean;
    prefix?: string;
}

export const Select = ({ currentSporsmal, showFeilmelding, prefix }: Props) => {
    const dispatch = useSporsmalsflytDispatch();

    const onChange = (value: SvarId) => {
        dispatch(updateSvarId(value));
    };

    const defaultSelectOptionValue = SvarId.InitiellVerdiForSelect;
    const defaultValue: SelectValue = {
        text: currentSporsmal.sporsmal.defaultOptionText,
        value: defaultSelectOptionValue,
        key: defaultSelectOptionValue,
        id: defaultSelectOptionValue,
        disabled: true,
    };

    return (
        <div className="container__standard-width">
            <SelectStyleguide
                label={currentSporsmal.sporsmal.tekst}
                sublabel={currentSporsmal.sporsmal.ingress}
                values={[defaultValue, ...toValues(currentSporsmal.sporsmal.alternativer, prefix)]}
                defaultValue={currentSporsmal.svarId || defaultValue.value}
                onChange={(event) => onChange(event.target.value as SvarId)} // TODO: Maren er dette innafor??
                error={
                    showFeilmelding && currentSporsmal.svarId === undefined ? 'Du må velge et alternativ' : undefined
                }
            />
        </div>
    );
};
